import { identify } from '@streamelements/alchemy';
import { observable, computed, action } from 'mobx';
import { authService } from '../../services/index';

class Auth {
  @observable userData = null;
  @observable connectionState = authService.loginStatesEnum.PENDING;
  @observable isUserLoggedIn = false;

  constructor () {
    this.fetchUserData();
  }

  @action
  fetchUserData () {
    authService.getUser()
      .then(channel => {
        this.userData = channel;
        this.connectionState = authService.loginStatesEnum.SUCCESS;
        this.isUserLoggedIn = true;
        identify({
          channelId: channel._id
        });
      })
      .catch((e) => {
        console.log('e', e);
        this.connectionState = authService.loginStatesEnum.FAILED;
        this.isUserLoggedIn = false;
      });
  }

}

export default Auth;




// WEBPACK FOOTER //
// ./src/app/models/Auth.js